export class AzureMapConfig {
    center: number[] = []; // where to center the map, if empty, it will be centered on the first marker
    determineMarkerType: boolean = true; // decides whether to use html markers or cluster layers based on count of items
    zoom: number = 4; // how far to zoom the map
    showControls: boolean = true;
    showPopups: boolean = false;
}
